import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrush = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "icon icon-tabler icons-tabler-outline icon-tabler-brush",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			stroke: "none",
			d: "M0 0h24v24H0z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M3 21v-4a4 4 0 1 1 4 4h-4" }),
		/* @__PURE__ */ _jsx("path", { d: "M21 3a16 16 0 0 0 -12.8 10.2" }),
		/* @__PURE__ */ _jsx("path", { d: "M21 3a16 16 0 0 1 -10.2 12.8" }),
		/* @__PURE__ */ _jsx("path", { d: "M10.6 9a9 9 0 0 1 4.4 4.4" })
	]
});
const ForwardRef = forwardRef(SvgBrush);
export default ForwardRef;
